import axios from "axios";
import { ActionContext } from "vuex";
import { Module, VuexModule, Mutation, Action, getModule } from "vuex-module-decorators";
import {
	store,
	db,
	VIPUser,
	IVIPUserOptions,
	IAuthRestResponse,
	IErrorRestResponse,
	RestAPI,
	toaster,
	IRestResult,
	commitToasterToast,
	VIPUserRest,
} from "@/loader";

export interface IAuthRestRequest {
	username: string;
	password: string;
	options?: IVIPUserOptions;
}

const namespace: string = "vip/v1";
const endpoint: string = "auth";

function getURL(...urlParts: string[]): string {
	let url: string[] = [RestAPI.url.replace(/\/$/, ""), namespace, endpoint, ...urlParts];
	return url.join("/");
}
function saveState(state: AuthModule) {
	localStorage.setItem("vipAuth", JSON.stringify({ ...state, user: state.user }));
}

@Module({
	name: "auth",
	store,
	dynamic: true,
	namespaced: true,
})
export class AuthModule extends VuexModule {
	public userID: number = 0;
	public token: string = "";
	public initialized: boolean = false;

	public get user(): VIPUser | null {
		return db.users.get(this.userID);
	}

	public get isLoggedIn(): boolean {
		return this.userID > 0;
	}

	@Mutation
	public init() {
		this.initialized = true;
		let t = localStorage.getItem("vipAuth");
		if (t) {
			let data: any = JSON.parse(t);
			let item: VIPUser | null = null;
			if (data.user) {
				item = db.users.insertOrUpdate(data.user);
			}
			this.userID = Number.orDefault(data.userID);
			this.token = String.orDefault(data.token);
			if (this.token) {
				axios.defaults.headers.Authorization = "Bearer " + this.token;
			}
			if (this.userID) {
				VIPUserRest.get({ id: this.userID }).then(result => {
					if (!result.success) {
						this.userID = 0;
						this.token = "";
						if (axios.defaults.headers.Authorization) {
							delete axios.defaults.headers.Authorization;
						}
						saveState(this);
					}
				}).catch(error => {
					console.log(error);
				});
			}
			// toaster.toast({ message: "Bonjour " + (item?.first_name || ""), variant: "info" });
		}
	}

	@Mutation
	public loggedIn(data: IAuthRestResponse) {
		this.userID = Number.orDefault(data.user.id);
		this.token = String.orDefault(data.token);

		axios.defaults.headers.Authorization = "Bearer " + this.token;

		let item = db.users.insertOrUpdate(data.user);
		saveState(this);
		toaster.toast({ message: "Bonjour " + (item.first_name || ""), variant: "info" });
		return item;
	}

	@Mutation
	public logout() {
		if (this.user) {
			toaster.toast({ message: "Au revoir " + (this.user.first_name || ""), variant: "info" });
		}

		this.userID = 0;
		this.token = "";
		if (axios.defaults.headers.Authorization) {
			delete axios.defaults.headers.Authorization;
		}
		saveState(this);
	}

	@Action
	public async validate(): Promise<IRestResult<VIPUser>> {
		return await axios.get<IAuthRestResponse>(getURL("validate")).then(response => {
			commitAuthLoggedIn(this.context, response.data);
			return <IRestResult<VIPUser>>{ success: true };
		}).catch((error: IErrorRestResponse) => {
			commitAuthLogout(this.context);
			commitToasterToast(this.context, { message: error.message, variant: "danger", noAutoHide: true });
			return <IRestResult<VIPUser>>{ success: false, error };
		});
	}

	@Action
	public async login(data: IAuthRestRequest): Promise<IRestResult<VIPUser>> {
		return await axios.post<IAuthRestResponse>(getURL(), data).then(response => {
			commitAuthLoggedIn(this.context, response.data);
			return <IRestResult<VIPUser>>{ success: true };
		}).catch((error: IErrorRestResponse) => {
			commitAuthLogout(this.context);
			commitToasterToast(this.context, { message: error.message, variant: "danger", noAutoHide: true });
			return <IRestResult<VIPUser>>{ success: false, error };
		});
	}

	@Action
	public async renew(): Promise<IRestResult<VIPUser>> {
		return await axios.get<IAuthRestResponse>(getURL("renew")).then(response => {
			commitAuthLoggedIn(this.context, response.data);
			return <IRestResult<VIPUser>>{ success: true };
		}).catch((error: IErrorRestResponse) => {
			commitAuthLogout(this.context);
			commitToasterToast(this.context, { message: error.message, variant: "danger", noAutoHide: true });
			return <IRestResult<VIPUser>>{ success: false, error };
		});
	}
}

export const auth = getModule(AuthModule, store);

export function commitAuthLoggedIn(context: ActionContext<any, any>, payload: IAuthRestResponse) {
	context.commit("auth/loggedIn", payload, { root: true });
}

export function commitAuthLogout(context: ActionContext<any, any>) {
	context.commit("auth/logout", null, { root: true });
}
